/* eslint-disable no-new */
import React from 'react'
import ReactDOM from 'react-dom'
import '@fortawesome/fontawesome-pro/css/all.min.css'
import { ScrollSpy } from 'bootstrap/dist/js/bootstrap.bundle'
import './i18n'
import './index.scss'

import $ from 'jquery'
import App from './App/App'

ReactDOM.render(<App />, document.getElementById('root'))

$(document).ready(function () {
  new ScrollSpy(document.querySelector('body'))

  $(window).scroll(function () {
    if ($(document).scrollTop() > 64) {
      $('#navbar').addClass('shrink')
    } else {
      $('#navbar').removeClass('shrink')
    }
  })
  $('#navbar .nav-link').on('click', function () {
    const id = $(this).attr('href')
    document.querySelector(id).scrollIntoView()
    return false
  })
})
